var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** マイページ開設 */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import RowTemplate from '../atoms/RowTemplate';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { http_status, module_name, api_response_type } from '../Const';
import { jumpUrl } from '../Common';
var NypageEntry = function () {
    // マイページ開設同意画面のリンク先
    var back_url = process.env.MIX_MOCK_URL + "/agreement";
    // ログインIDのstate
    var _a = useState(''), login_id = _a[0], setLoginId = _a[1];
    // パスワード
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    // パスワード(確認)
    var _c = useState(''), password_confirmation = _c[0], setPasswordConfirmation = _c[1];
    // マイページ開設開設結果
    var _d = useState([]), mypage_open_result = _d[0], setMypageOpenResult = _d[1];
    // HTTPステータスコード
    var _e = useState(0), status_code = _e[0], setStatusCode = _e[1];
    // Ajax通信中フラグ
    var _f = useState(false), is_connecting = _f[0], setIsConnecting = _f[1];
    // ローディング画面表示状態
    var _g = useState(false), is_loading = _g[0], setIsLoading = _g[1];
    // 案件情報
    var _h = useState(0), reception_id = _h[0], setReceptionId = _h[1];
    var _j = useState(''), reception_cd = _j[0], setReceptionCd = _j[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        getReceptionInfo();
    }, []);
    /**
     * 案件情報を取得する
     */
    var getReceptionInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, axios.get('/entry/reception_info')];
                case 1:
                    response = _a.sent();
                    setReceptionId(response.data.reception_id);
                    setReceptionCd(response.data.reception_cd);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleLoginIdChange = useCallback(function (event) {
        setLoginId(event.target.value);
    }, []);
    var handlePasswordChange = useCallback(function (event) {
        setPassword(event.target.value);
    }, []);
    var handlePasswordConfirmationChange = useCallback(function (event) {
        setPasswordConfirmation(event.target.value);
    }, []);
    // マイページ開設ボタンのクリックイベントを定義
    var handleClick = function () {
        // ログイン情報をStateへセット
        var send_mypage_info = {
            login_id: login_id,
            password: password,
            password_confirmation: password_confirmation,
        };
        var mypageOpen = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post('/entry/entry_proc', send_mypage_info)];
                    case 1:
                        response = _a.sent();
                        // 成功
                        if (response.status === http_status.created) {
                            requestModule();
                        }
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        jumpUrl(error_2.response.data.url);
                        // 失敗
                        setMypageOpenResult(error_2.response.data.message);
                        setStatusCode(error_2.response.status);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // パスワード変更処理
        mypageOpen();
    };
    /**
     * API呼び出し処理
     */
    var requestModule = function () { return __awaiter(void 0, void 0, void 0, function () {
        var post_data, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    post_data = {
                        reception_id: reception_id,
                        reception_cd: reception_cd,
                        module_name: module_name.mypage_open,
                        detail: [],
                        is_json: true,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.post('/api/common', post_data)];
                case 2:
                    response = _a.sent();
                    // 正常なレスポンス
                    if (response.data.result &&
                        response.data.response_type === api_response_type.transition_to_mypage_complete) {
                        // マイページ開設完了画面へ遷移
                        location.replace(process.env.MIX_MOCK_URL + "/entry/complete");
                        // 異常なレスポンス
                    }
                    else {
                        console.log(response.data);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    console.log(error_3);
                    jumpUrl(error_3.response.data.url);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    setIsConnecting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container mx-auto col-11" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12 col-md-12 mx-auto my-2" },
                    React.createElement("b", null, "\u6B21\u306B\u3001\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3059\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"))),
            React.createElement("h4", { className: "title p-2 my-2" }, "\u30DE\u30A4\u30DA\u30FC\u30B8\u958B\u8A2D"),
            React.createElement("div", null,
                React.createElement("p", { className: "p-lead" }, "\u4EEE\u7533\u8FBC\u6642\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
            React.createElement("div", null,
                React.createElement("form", { className: "form", method: "post" },
                    React.createElement(RowTemplate, { label: "\u30ED\u30B0\u30A4\u30F3ID", content: React.createElement("div", { className: "p-title-with-input" },
                            React.createElement("div", { className: "p-text-with-input" },
                                React.createElement("div", { className: "text-with-input-box" },
                                    React.createElement("input", { className: "c-input input-l", name: "login_id", type: "text", placeholder: "example@example.com", onChange: handleLoginIdChange, maxLength: 200 })))) }),
                    React.createElement("div", null, "\u203B\u5165\u529B\u3044\u305F\u3060\u304F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u91CD\u8981\u306A\u304A\u77E5\u3089\u305B\u3092\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002"),
                    React.createElement("div", { className: "mt-3" }, "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u305F\u3081\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement("div", null,
                        React.createElement(RowTemplate, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9", content: React.createElement("div", { className: "p-title-with-input" },
                                React.createElement("div", { className: "p-text-with-input" },
                                    React.createElement("div", { className: "text-with-input-box" },
                                        React.createElement("input", { className: "c-input input-l", name: "password", type: "password", placeholder: "XXXXXX", onChange: handlePasswordChange, maxLength: 200 })))) })),
                    React.createElement(RowTemplate, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9\uFF08\u78BA\u8A8D\u7528\uFF09", content: React.createElement("div", { className: "p-title-with-input" },
                            React.createElement("div", { className: "p-text-with-input" },
                                React.createElement("div", { className: "text-with-input-box" },
                                    React.createElement("input", { className: "c-input input-l", name: "password_confirmation", type: "password", placeholder: "XXXXXX", onChange: handlePasswordConfirmationChange, maxLength: 200 })))) }),
                    React.createElement("p", null, "\u203B\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u3001\u82F1\u5B57\u30FB\u6570\u5B57\u3092\u542B\u30808\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement("div", { className: "mt-3" }),
                    mypage_open_result !== undefined &&
                        // マイページ開設結果メッセージあり
                        // @see HTTPステータスコード一覧 - Symfony\Component\HttpFoundation\Response
                        status_code >= 400 &&
                        status_code <= 511 && (
                    // 失敗
                    React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                        React.createElement(Col, null),
                        React.createElement(Col, { md: 9, className: "alert-danger pt-3" },
                            React.createElement("ul", null, mypage_open_result.map(function (error_message, index) {
                                return React.createElement("li", { key: index }, error_message);
                            }))))),
                    React.createElement("div", { className: "p-next-btn-box" },
                        React.createElement("button", { className: "c-btn btn-max btn-main-color", type: "button", onClick: handleClick, "data-jump_to": "#" }, "\u30DE\u30A4\u30DA\u30FC\u30B8\u3092\u958B\u8A2D\u3059\u308B"))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12 col-md-12" },
                        React.createElement("div", { className: "p-back-btn-box" },
                            React.createElement("a", { className: "c-btn btn-large btn-main-color mx-auto", "data-back": true, href: back_url }, "\u623B\u308B"))),
                    React.createElement("div", { className: "col-md-4 ml-auto" })))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('mypage-entry')) {
    render(React.createElement(NypageEntry, null), document.getElementById('mypage-entry'));
}
